import { Badge } from "@/components/ui/badge";
import { useTran } from "@/hooks";
import { observer } from "mobx-react-lite";
import { getDisclosureDescription } from "@/features/esg/utils/disclosure-utils";

const DataEntryDescription = observer(({ disclosure }) => {
  const { t } = useTran();
  const description = getDisclosureDescription(disclosure);

  return (
    <div className="flex h-full min-h-0 flex-col rounded-radius bg-card border-border border">
      <div className="p-3 border-b border-border">
        <p className="text-sm font-medium">{t("Detailed Description")}</p>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-3">
        {description ? (
          <p className="text-xs text-muted-foreground leading-relaxed">
            {t(description)}
          </p>
        ) : (
          <p className="text-xs text-muted-foreground italic">
            {t("No description available")}
          </p>
        )}

        <div className="space-y-2 pt-2 border-t border-border">
          {disclosure.framework && (
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">
                {t("Framework")}
              </span>
              <span className="text-xs font-medium">
                {disclosure.framework}
              </span>
            </div>
          )}
          {disclosure.category && (
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">
                {t("Category")}
              </span>
              <span className="text-xs font-medium">{disclosure.category}</span>
            </div>
          )}
          {disclosure.frequency && (
            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">
                {t("Frequency")}
              </span>
              <span className="text-xs font-medium capitalize">
                {disclosure.frequency}
              </span>
            </div>
          )}
          {disclosure.unitOptions?.length > 0 && (
            <div>
              <span className="text-xs text-muted-foreground">
                {t("Unit Options")}
              </span>
              <div className="flex flex-wrap gap-1 mt-1">
                {disclosure.unitOptions.map((unit) => (
                  <Badge key={unit} variant="outline" className="text-xs">
                    {unit}
                  </Badge>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default DataEntryDescription;
